import { NoInputType } from '../InputTypes';
import { makeOperator } from './Operator';
export default makeOperator({
  inputType: NoInputType,
  name: 'MissingAssociationBranchFilter',
  values: [{
    name: 'value',
    isValid: value => typeof value === 'object' && value !== null
  }]
});